export default "__VITE_ASSET__DEeAA0El__"